import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, SecurityContext } from '@angular/core';
import { UiLinkModule } from '@big-direkt/ui/link';
import { UiSvgIconModule } from '@big-direkt/ui/svg-icon';
import { IconBigMediumPfeilRechts, IconComponent } from '@big-direkt/utils/icons';
import { Nl2brPipe, SanitizePipe } from '@big-direkt/utils/shared';
import { TranslocoDirective } from '@jsverse/transloco';
import { CardBaseComponent } from '../../card-base.component';
import { CardComponent } from '../card/card.component';
import { UiCardIconLeftHlTextLinkModel } from './card-icon-left-hl-text-link.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'big-ui-card-icon-left-hl-text-link',
    templateUrl: './card-icon-left-hl-text-link.component.html',
    imports: [CardComponent, IconComponent, NgClass, Nl2brPipe, SanitizePipe, TranslocoDirective, UiLinkModule, UiSvgIconModule],
})
export class CardIconLeftHlTextLinkComponent extends CardBaseComponent {
    public readonly securityContext: SecurityContext = SecurityContext.HTML;
    public readonly iconArrowRight = IconBigMediumPfeilRechts;

    @Input() public data!: UiCardIconLeftHlTextLinkModel;
    @Input() public iconCssClass = '[&>svg]:w-14! [&>svg]:h-14! fill-primary group-hover/item:fill-primary-light';
    @Input() public iconSvgCssClass = 'flex shrink-0 w-10 mr-4 fill-primary';
}
